import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http'; // Import pour l'HTTP
import { Observable } from 'rxjs'; // Import pour l'observable
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-test',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent {
  testForm: FormGroup;
  message: string = ''; // Variable pour afficher le message

  constructor(private fb: FormBuilder, private api: AuthService) {
    this.testForm = this.fb.group({
      input: ['', [Validators.required, Validators.email]] // Validation de l'email
    });
  }

  onSubmit() {
    if (this.testForm.valid) {
      const email = this.testForm.value.input;
      console.log('Form submitted with email:', email);
      this.api.reset_password_request({ email }).subscribe(
        (response) => {
          console.log(response);
          this.message = 'Email de réinitialisation envoyé avec succès.'; // Message de succès
        },
        (error) => {
          console.error(error);
          this.message = 'Une erreur est survenue. Veuillez réessayer.'; // Message d'erreur
        }
      );
    }
  }
}
